import Nav from '../../../Global/Nav.vue'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import E from 'wangeditor'

export default {
  name: 'WebsitesList',
  components: {
    Nav,
    quillEditor
  },
  data() {
    return {
      titleConfig: [
        { Choice: '.ql-insertMetric', title: '跳转配置' },
        { Choice: '.ql-bold', title: '加粗' },
        { Choice: '.ql-italic', title: '斜体' },
        { Choice: '.ql-underline', title: '下划线' },
        { Choice: '.ql-header', title: '段落格式' },
        { Choice: '.ql-strike', title: '删除线' },
        { Choice: '.ql-blockquote', title: '块引用' },
        { Choice: '.ql-code', title: '插入代码' },
        { Choice: '.ql-code-block', title: '插入代码段' },
        { Choice: '.ql-font', title: '字体' },
        { Choice: '.ql-size', title: '字体大小' },
        { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
        { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
        { Choice: '.ql-direction', title: '文本方向' },
        { Choice: '.ql-header[value="1"]', title: 'h1' },
        { Choice: '.ql-header[value="2"]', title: 'h2' },
        { Choice: '.ql-align', title: '对齐方式' },
        { Choice: '.ql-color', title: '字体颜色' },
        { Choice: '.ql-background', title: '背景颜色' },
        { Choice: '.ql-image', title: '图像' },
        { Choice: '.ql-video', title: '视频' },
        { Choice: '.ql-link', title: '添加链接' },
        { Choice: '.ql-formula', title: '插入公式' },
        { Choice: '.ql-clean', title: '清除字体格式' },
        { Choice: '.ql-script[value="sub"]', title: '下标' },
        { Choice: '.ql-script[value="super"]', title: '上标' },
        { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
        { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
        { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
        { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
        { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
        { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
        { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
        { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
        { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
        { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
        { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
        { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
        { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
        { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
        { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
      ],
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'], // 加粗 斜体 下划线 删除线
            [{ size: [12, 14, 16] }], // 字体大小
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ align: [] }], // 对齐方式
            ['clean'], // 清除文本格式
            ['link', 'image', 'video'] // 链接、图片、视频
            // ['link'] // 链接、图片、视频
          ]
        },
        placeholder: '请输入正文'
      },
      wEditor: null,
      settingHtmlFlag: false,
      uploadApi: this.$axios.defaults.baseURL + 'websites/backend/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      activeName: 'basic',
      timingOptions: [],
      loading: true,
      domain: '',
      lang: 'en',
      languages: {},
      website: {
        turning_email_pool_info: {
          id: null,
          title: '',
          period: null,
          details: ''
        },
        creator: {},
        saler: {},
        authority_score: ''
      },
      editTurningEmailPoolVisible: false,
      salers: [],
      saler: {
        id: '',
        saler: '',
        mobile: '',
        telephone: '',
        whatsapp: '',
        instagram: '',
        skype: '',
        facebook: '',
        vk: '',
        telegram: '',
        viber: '',
        address: '',
        qr: '',
        google_map_src: ''
      },
      salersVisible: false,
      salersLoading: false,
      editSalerVisible: false,
      editSalerLoading: false,
      pageSettingsVisible: false,
      pageSettingsLoading: false,
      pageSettingsData: [],
      pagesList: [],
      pagesLoading: false,
      pagesDetailVisible: false,
      pagesDetailTitle: '',
      pagesDetailLoading: false,
      pagesDetailLoadingText: '',
      pagesDetailForm: {
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        content: ''
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      footerPageSettingsVisible: false,
      footerPageSettingsLoading: false,
      footerPageSettingsData: [],
      footerDefaultExpandedKeys: [],
      footerDefaultCheckedKeys: [],
      logoSettingsVisible: false,
      logoInfo: {},
      bladesloading: true,
      bladesloadingText: '',
      bladesList: [],
      colorSettingsVisible: false,
      siteColors: {
        first: '',
        second: '',
        third: ''
      },
      mediaType: 'images',
      mediaList: [],
      medialoading: true,
      cursor: null,
      hasMore: true,
      loadingMore: false,
      scrollTimer: null,
      renamedMediaName: '',
      uploadMediaVisible: false,
      uploadMediaList: [],
      productsKeywords: '',
      productsLoading: false,
      productsList: [],
      productsTotal: 0,
      productsSize: 10,
      productsPage: 1,
      productDetailLoading: false,
      productDetailVisible: false,
      productDetailDiaTitle: '',
      productDetailLoadingText: '',
      productDetail: {
        product: '',
        cas: '',
        category_id: '',
        type: '',
        url: '',
        shape: '',
        specifications: '',
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        covers: [],
        properties: [],
        packing_storage: {
          packing: '',
          storage: '',
          shipping: '',
          container_loading: '',
          shelf_life: ''
        },
        generals: [],
        faqs: []
      },
      productDetailRules: {},
      uploadProductsVisible: false,
      uploadProductsLoading: false,
      uploadProductsFileList: [],
      manageProductsCategoriesVisible: false,
      productCategoriesLoading: true,
      productCategoriesOptions: [],
      productCategoriesData: [],
      hoveredNodeId: null,
      currentValue: '',
      productCategoriesForm: {
        category: '',
        parent_id: ''
      },
      newsKeywords: '',
      newsLoading: false,
      newsList: [],
      newsTotal: 0,
      newsSize: 10,
      newsPage: 1,
      newsDetailTitle: '',
      newsDetailLoading: false,
      newsDetailVisible: false,
      newsDetailForm: {
        title: '',
        url: '',
        content: '',
        keywords: '',
        description: '',
        og_title: '',
        og_description: ''
      },
      newsDetailRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'commit' }
        ]
      },
      supplementsActive: false,
      supplementsKeywords: '',
      supplementsLoading: false,
      supplementsProgress: {
        percentage: 0,
        done: 0,
        undo: 0
      },
      supplementsList: [],
      supplementsTotal: 0,
      supplementsSize: 10,
      supplementsPage: 1,
      supplementsDetailTitle: '',
      supplementsDetailLoading: false,
      supplementsDetailVisible: false,
      supplementsDetailForm: {
        title: '',
        url: '',
        content: '',
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        weight_value: 0
      },
      supplementsDetailRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'commit' }
        ]
      },
      uploadSupplementsVisible: false,
      uploadSupplementsLoading: false,
      uploadSupplementsFileList: [],
      supplementsSettingsVisible: false,
      supplementsSettingsLoading: false,
      supplementsSettingsLoadingText: '',
      supplementsSettingsForm: {
        quantity: 2,
        timing: "02:00"
      },
      supplementsSettingsRules: {
        quantity: [
          { required: true, message: '发布数量不合法', trigger: 'commit' }
        ]
      },
      seoForm: {
        google_site_verification: '',
        google_analysis_id: '',
        bing_site_auth: '',
        yandex_site_auth: '',
        baidu_site_auth: '',
        sitemap: []
      },
      seoList: [],
      seoLoading: false,
      multilingualLanguagesList: [],
      multilingualLanguagesLoading: false,
      addMultilingualLanguagesVisible: false,
      addMultilingualLanguagesForm: {
        checkedValues: []
      },
      addMultilingualLanguagesFormCheckers: [],
      addMultilingualLanguagesLoading: false,
      addMultilingualLanguagesLoadingText: '',
      redoMultilingualLanguagesTitle: '',
      redoMultilingualLanguagesVisible: false,
      redoMultilingualLanguagesLoading: false,
      redoMultilingualLanguagesForm: {
        domain: '',
        type: '',
        action: '补充',
        lang: ''
      },
      partnersList: [],
      partnersLoading: false,
      uploadPartnersVisible: false,
      uploadPartnersList: [],
      knowledgeType: 'products',
      knowledgeKeywords: '',
      knowledgeLoading: false,
      knowledgeList: [],
      knowledgeTotal: 0,
      knowledgeSize: 10,
      knowledgePage: 1,
      knowledgeDetailTitle: '',
      knowledgeDetailVisible: false,
      knowledgeDetailLoading: false,
      knowledgeDetailForm: {
        word: '',
        is_regean: false,
        batch: ''
      },
      knowledgeDetailRules: {
        word: [
          { required: true, message: '本项不能为空', trigger: 'commit' }
        ]
      },
      uploadKnowledgeVisible: false,
      uploadKnowledgeLoading: false,
      uploadKnowledgeFileList: [],
      contentsType: 'product_category',
      contentsTypes: [],
      contentsLoading: false,
      contentsList: [],
      contentsTotal: 0,
      contentsSize: 10,
      contentsDetailTitle: '',
      contentsDetailVisible: false,
      contentsDetailLoading: false,
      contentsDetailForm: {},
      contentsDetailRules: {},
      packagesList: [],
      categoryPackageTitle: '',
      categoryPackageVisible: false,
      categoryPackageLoading: false,
      categoryPackagePreviewLoading: false,
      categoryPackageForm: {
        package_id: '',
        src: '',
        category_id: ''
      },
      redoProductPackagesVisible: false,
      redoProductPackagesLoading: false,
      redoProductPackagesForm: {
        checkAll: false,
        checkedTypes: [],
        packageTypes: ['包装', '小样', '2D', '3D'],
        isIndeterminate: true
      },
      deployInfo: {
        'expire_date': '',
        'dns_status': '',
        'tencent_balance': '',
        'aliyun_balance': ''
      },
      deployList: [],
      deployForm: {
        items: []
      },
      selectedIdSet: new Set(),
      deployOptions: [
        { label: '全球(不含大陆)', value: 'overseas' },
        { label: '全球', value: 'global' },
        { label: '仅中国大陆', value: 'domestic' }
      ],
      internalLinkKeywords: '',
      internalLinkLoading: false,
      internalLinkList: [],
      internalLinkTotal: 0,
      internalLinkSize: 10,
      internalLinkPage: 1,
      internalLinkDetailVisible: false,
      internalLinkDetailLoading: false,
      internalLinkDetailForm: {
        id: '',
        domain: this.domain,
        keyword: ''
      },
      internalLinkDetailRules: {
        keyword: [
          { required: true, message: '本项不能为空', trigger: 'commit' }
        ]
      },
      uploadInternalLinkVisible: false,
      uploadInternalLinkLoading: false,
      uploadInternalLinkFileList: [],

      sideLoadingList: [],
      sideLoadingsLoading: false,
      uploadSideLoadingVisible: false,
      uploadSideLoadingLoading: false,
      uploadSideLoadingFileList: []
    }
  },
  created() {
    this.domain = this.$route.params.domain;
    this.lang = this.$route.query.lang || 'en';
    this.init();
    for (let i = 0; i < 24; i++) {
      const hour = String(i).padStart(2, '0');
      const value = `${hour}:00`;
      this.timingOptions.push({
        label: value,
        value: value
      });
    }
  },
  watch: {
    'productDetail.s3'(val) {
      if (!this.wEditor) return

      const currentHtml = this.wEditor.txt.html()

      if (val !== currentHtml) {
        this.settingHtmlFlag = true
        this.wEditor.txt.html(val || '')
        this.settingHtmlFlag = false
      }
    }
  },
  mounted() {
    this.bindMediaScroll();
  },
  methods: {
    onDialogOpenedEditor() {
      // dialog 打开并渲染完成后再 init
      this.$nextTick(() => {
        this.initWangEditor()
      })
    },

    onDialogClosedEditor() {
      this.destroyWangEditor()
    },

    initWangEditor() {
      if (this.wEditor) return

      const toolbar = this.$refs.wToolbar
      const editorEl = this.$refs.wEditor
      if (!toolbar || !editorEl) {
        console.error('wangeditor refs missing:', { toolbar, editorEl })
        return
      }

      const editor = new E(toolbar, editorEl)

      editor.config.placeholder = '请输入正文'
      editor.config.height = 360

      editor.config.menus = [
        'head', 'bold', 'italic', 'underline', 'strikeThrough',
        'foreColor', 'backColor', 'link', 'list', 'justify',
        'quote', 'image', 'video', 'table', 'code', 'undo', 'redo'
      ]

      // 内容变化 => 写回你的字段
      editor.config.onchange = (html) => {
        if (this.settingHtmlFlag) return
        this.productDetail.s3 = html
      }

      editor.create()
      this.wEditor = editor

      // 初始化回填已有内容
      this.settingHtmlFlag = true
      editor.txt.html(this.productDetail.s3 || '')
      this.settingHtmlFlag = false
    },

    destroyWangEditor() {
      if (this.wEditor) {
        this.wEditor.destroy()
        this.wEditor = null
      }
    },
    tabClick(tab, event) {
      switch (tab.name) {
        case 'basic':
          this.init();
          break;
        case 'blades':
          this.getBladesList();
          break;
        case 'pages':
          this.getPagesList();
          break;
        case 'media':
          this.getMedia();
          break;
        case 'products':
          this.queryProductsList();
          break;
        case 'news':
          this.queryNewsList();
          break;
        case 'supplements':
          this.querySupplementsList();
          break;
        case 'contents':
          this.queryContentsList();
          break;
        case 'seo':
          this.getSeo();
          break;
        case 'internationalization':
          this.getMultilingualManguages();
          break;
        case 'partners':
          this.getPartners();
          break;
        case 'knowledge':
          this.queryKnowledgeList();
          break;
        case 'deploy':
          this.queryDeploy();
          this.$nextTick(() => {
            this.$refs.multipleTable.doLayout();
          });
          break;
        case 'internal_link':
          this.queryInternalLinkList();
          break;
        case 'side_loading':
          this.querySideLoadingsList();
          break;
      }
    },
    async init() {
      await this.$axios.get(`/websites/backend/detail?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.website = response.data.data
        }
      })
      await this.$axios.get(`/websites/backend/salers`).then((response) => {
        if (response.data.code === 200) {
          this.salers = response.data.data
        }
      })
      await this.$axios.get(`/websites/backend/languages?domain=${this.domain}`).then((response) => {
        if (response.data.code === 200) {
          this.languages = response.data.data
        }
      })
    },
    copy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    view(url) {
      const windowFeatures = 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,fullscreen=yes,channelmode=yes';
      window.open('http://' + url, '_blank', windowFeatures);
    },
    showSalers() {
      this.salersVisible = true;
    },
    addSaler() {
      this.saler = {
        id: '',
        saler: '',
        mobile: '',
        telephone: '',
        whatsapp: '',
        instagram: '',
        skype: '',
        facebook: '',
        vk: '',
        telegram: '',
        viber: '',
        address: '',
        qr: '',
        google_map_src: ''
      }
      this.editSalerVisible = true;
    },
    editSaler(row) {
      this.saler = row;
      this.editSalerVisible = true;
    },
    async saveSaler() {
      this.editSalerLoading = true;
      await this.$axios.post(`/websites/backend/saler/save`, {
        domain: this.domain,
        saler: this.saler
      }).then((response) => {
        this.editSalerLoading = false;
        if (response.data.code === 200) {
          this.editSalerVisible = false;
          this.init();
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    async deleteSaler(row) {
      this.salersLoading = true
      await this.$axios.post(`/websites/backend/saler/delete`, {
        domain: this.domain,
        saler: row
      }).then((response) => {
        if (response.data.code === 200) {
          this.init();
        }
      }).finally(() => {
        this.salersLoading = false;
      });
    },
    async chooseSaler(row) {
      this.salersLoading = true
      await this.$axios.post(`/websites/backend/saler/choose`, {
        domain: this.domain,
        saler: row
      }).then((response) => {
        if (response.data.code === 200) {
          this.init();
        }
      }).finally(() => {
        this.salersLoading = false;
      });
    },
    saveTurningEmailPool() {
      this.$confirm('保存后网站主邮箱将会立即生效, 确定吗', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.store();
      })
    },
    store() {
      this.$axios.post(`/websites/backend/store`, this.website).then((response) => {
        if (response.data.code === 200) {
          this.editTurningEmailPoolVisible = false;
          this.init();
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    deleteTurningEmailPool() {
      this.$confirm('确定删除轮换邮箱吗? 此操作不可恢复', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/websites/backend/delete_turning_email_pool`, {
          web_id: this.website.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.init();
            this.$message({
              message: '已保存',
              type: 'success'
            });
          }
        })
      });
    },
    deleteWebsite() {
      const l = this.lang;
      const notice = (l === 'en' || l === '' || l === null || l === undefined) ? '删除后网站将无法访问, 并且多语种网站会一并删除, 此操作不可恢复, 确定吗?' : ('此操作将删除' + this.languages[l] + '站, 其余站点不影响, 此操作不可恢复, 确定吗?');
      this.$confirm(notice, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const n = {
          domain: this.domain,
          lang: l
        }
        this.$axios.post('/websites/backend/delete', n).then((response) => {
          const message = (l === 'en' || l === '' || l === null || l === undefined) ? this.domain : (l + '.' + this.domain)
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: message + '已经删除',
              type: 'success'
            });
            this.$router.push({
              name: 'websites_list'
            });
          }
        })
      }).catch();
    },
    refreshCDN() {
      this.$axios.post('/websites/backend/cdn/refresh', {
        domain: this.domain,
        type: 'master'
      }).then((response) => {
        if (response.data.code === 200) {
          this.$notify({
            title: '刷新成功',
            message: '今日剩余次数:' + response.data.data,
            type: 'success'
          });
        }
      })
    },
    refreshCDNV2(row) {
      let status = row.status;
      if (status !== '已完成') {
        this.$message({
          type: 'error',
          message: '当前状态不可刷新'
        })
      } else {
        let domain = row.subdomain === '@' ? this.domain : (row.subdomain + '.' + this.domain);
        this.$axios.post('/websites/backend/cdn/refresh', {
          domain: domain,
          type: 'normal'
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '刷新成功',
              message: '今日剩余次数:' + response.data.data,
              type: 'success'
            });
          }
        })
      }
    },
    pageSettings() {
      this.pageSettingsVisible = true;
      this.pageSettingsLoading = true;
      this.$axios.get(`/websites/backend/pages?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.pageSettingsLoading = false;
        if (response.data.code === 200) {
          this.pageSettingsData = response.data.data.data;
          this.defaultExpandedKeys = response.data.data.default_checked_keys;
          this.defaultCheckedKeys = response.data.data.default_checked_keys;
        }
      })
    },
    footerPageSettings() {
      this.footerPageSettingsVisible = true;
      this.footerPageSettingsLoading = true;
      this.$axios.get(`/websites/backend/pages/footer?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.footerPageSettingsLoading = false;
        if (response.data.code === 200) {
          this.footerPageSettingsData = response.data.data.data;
          this.fooyerDefaultExpandedKeys = response.data.data.default_checked_keys;
          this.footerDefaultCheckedKeys = response.data.data.default_checked_keys;
        }
      })
    },
    savePageSettings() {
      const checkedNodes = this.$refs.pageSettingsData.getCheckedNodes();
      const allNodes = [];
      const addedNodeIds = new Set();
      checkedNodes.forEach(node => {
        this.addNodeAndParents(node, allNodes, addedNodeIds);
      });
      this.$confirm('确定保存新的栏目设置吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.pageSettingsLoading = true;
        const n = {
          domain: this.domain,
          lang: this.lang,
          nodes: allNodes
        }
        this.$axios.post('/websites/backend/pages/save', n).then((response) => {
          this.pageSettingsLoading = false;
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: '保存成功',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    addNodeAndParents(node, allNodes, addedNodeIds) {
      const nodeInstance = this.$refs.pageSettingsData.getNode(node);
      if (nodeInstance && nodeInstance.parent && nodeInstance.parent.data) {
        const parentNode = nodeInstance.parent.data;
        const parentNodeInstance = this.$refs.pageSettingsData.getNode(parentNode);
        if (parentNodeInstance && (parentNodeInstance.checked || parentNodeInstance.indeterminate)) {
          this.addNodeAndParents(parentNode, allNodes, addedNodeIds);
        }
      }
      if (!addedNodeIds.has(node.id)) {
        allNodes.push(node);
        addedNodeIds.add(node.id);
      }
    },
    saveFooterPageSettings() {
      const checkedNodes = this.$refs.footerPageSettingsData.getCheckedNodes();
      const allNodes = [];
      const addedNodeIds = new Set();
      checkedNodes.forEach(node => {
        this.addNodeAndParentsFooter(node, allNodes, addedNodeIds);
      });
      this.$confirm('确定保存新的栏目设置吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.footerPageSettingsLoading = true;
        const n = {
          domain: this.domain,
          lang: this.lang,
          nodes: allNodes
        }
        this.$axios.post('/websites/backend/pages/save_footer', n).then((response) => {
          this.footerPageSettingsLoading = false;
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: '保存成功',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    addNodeAndParentsFooter(node, allNodes, addedNodeIds) {
      const nodeInstance = this.$refs.footerPageSettingsData.getNode(node);
      if (nodeInstance && nodeInstance.parent && nodeInstance.parent.data) {
        const parentNode = nodeInstance.parent.data;
        const parentNodeInstance = this.$refs.footerPageSettingsData.getNode(parentNode);
        if (parentNodeInstance && (parentNodeInstance.checked || parentNodeInstance.indeterminate)) {
          this.addNodeAndParents(parentNode, allNodes, addedNodeIds);
        }
      }
      if (!addedNodeIds.has(node.id)) {
        allNodes.push(node);
        addedNodeIds.add(node.id);
      }
    },
    async logoSettings() {
      this.logoInfo = {}
      this.logoSettingsVisible = true;
      await this.$axios.get(`/websites/backend/logo?domain=${this.domain}`).then((response) => {
        if (response.data.code === 200) {
          this.logoInfo = response.data.data;
        }
      })
    },
    uploadLogoSuccess(response) {
      if (response.code === 200) {
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.logoSettings();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    async colorSettings() {
      this.siteColors = {
        first: '',
        second: '',
        third: ''
      }
      this.colorSettingsVisible = true;
      this.$axios.get(`/websites/backend/colors?domain=${this.domain}`).then((response) => {
        if (response.data.code === 200) {
          this.siteColors = response.data.data;
        }
      }).catch();
    },
    saveColorSettings() {
      const d = {
        domain: this.domain,
        colors: this.siteColors
      };
      this.$axios.post(`/websites/backend/colors/save`, d).then((response) => {
        if (response.data.code === 200) {
          this.$notify({
            title: '操作成功',
            message: '新的色彩已经应用',
            type: 'success'
          });
        }
      }).catch();
    },
    getBladesList() {
      this.bladesloading = true;
      this.$axios.get(`/websites/backend/blades?domain=${this.domain}`).then((response) => {
        this.bladesloading = false;
        if (response.data.code === 200) {
          this.bladesList = response.data.data;
        }
      })
    },
    useBlade(item) {
      this.$confirm('此操作将替换网站模板, 并且将应用本模板默认初始样式(包括logo等图片), 此操作不可逆转, 确定执行吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.bladesloadingText = '正在应用模板, 请勿关闭或切换页面';
        this.bladesloading = true;
        this.$axios.post('/websites/backend/blades/use', {
          id: item.id,
          domain: this.domain
        }).then((response) => {
          this.bladesloading = false;
          if (response.data.code === 200) {
            this.getBladesList();
            this.$notify({
              title: '操作成功',
              message: item.title + ' 已经应用',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    getPagesList() {
      this.pagesLoading = true;
      this.$axios.get(`/websites/backend/pages?domain=${this.domain}&type=flatten&lang=${this.lang}`).then((response) => {
        this.pagesLoading = false;
        if (response.data.code === 200) {
          this.pagesList = response.data.data.data;
        }
      })
    },
    togglePagesStatus(row, index) {
      this.$axios.post('/websites/backend/pages/toggle_status', {
        id: row.id,
        lang: this.lang,
        status: row.status
      })
    },
    async editPage(row) {
      this.pagesDetailTitle = row.title;
      this.pagesDetailForm = {
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        content: ''
      }
      this.pagesDetailVisible = true;
      this.pagesDetailLoading = true;
      await this.$axios.get(`/websites/backend/pages/detail?id=${row.id}&lang=${this.lang}`).then((response) => {
        this.pagesDetailLoading = false;
        if (response.data.code === 200) {
          this.pagesDetailForm = response.data.data;
        }
      })
    },
    savePagesDetail() {
      this.pagesDetailLoading = true;
      this.pagesDetailForm.lang = this.lang
      this.$axios.post(`/websites/backend/pages/save_detail`, this.pagesDetailForm).then((response) => {
        this.pagesDetailLoading = false;
        if (response.data.code === 200) {
          this.getPagesList();
          this.pagesDetailVisible = false;
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    bindMediaScroll() {
      this.$nextTick(() => {
        const el = this.$refs.mediaScroll;
        if (!el) return;
        el.addEventListener('scroll', this.onMediaScroll, { passive: true });
      });
    },
    unbindMediaScroll() {
      const el = this.$refs.mediaScroll;
      if (!el) return;
      el.removeEventListener('scroll', this.onMediaScroll);
    },
    onMediaScroll() {
      // 简单节流：50ms
      if (this.scrollTimer) return;
      this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null;

        const el = this.$refs.mediaScroll;
        if (!el) return;

        const threshold = 200; // 距离底部 200px 开始加载
        const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

        if (nearBottom) {
          this.loadMoreMedia();
        }
      }, 50);
    },
    getMedia() {
      this.mediaList = [];
      this.cursor = null;
      this.hasMore = true;

      this.medialoading = true;
      return this.fetchMediaPage()
        .finally(() => {
          this.medialoading = false;
          this.$nextTick(() => this.maybeAutoFill());
        });
    },
    fetchMediaPage() {
      if (!this.hasMore) return Promise.resolve();
      if (this.loadingMore) return Promise.resolve();

      this.loadingMore = true;

      const params = {
        domain: this.domain,
        type: this.mediaType
      };
      if (this.cursor) params.cursor = this.cursor;

      return this.$axios.get('/websites/backend/media', { params })
        .then((response) => {
          if (response.data.code !== 200) return;

          const payload = response.data.data || {};
          const list = (payload.data || []).map(item => {
            const rawUrl = item.url;
            const url = rawUrl + (rawUrl.includes('?') ? '&' : '?') + 't=' + Date.now();

            return {
              ...item,
              rawUrl,
              url
            };
          });

          this.mediaList = this.mediaList.concat(list);

          this.cursor = payload.next_cursor || this.cursor;
          this.hasMore = !!payload.has_more;
        })
        .finally(() => {
          this.loadingMore = false;
        });
    },
    loadMoreMedia() {
      if (this.medialoading) return;
      if (!this.hasMore) return;
      if (this.loadingMore) return;

      this.fetchMediaPage()
        .then(() => {
          this.$nextTick(() => this.maybeAutoFill());
        });
    },
    maybeAutoFill() {
      const el = this.$refs.mediaScroll;
      if (!el) return;

      // 内容高度 <= 容器高度 + 一点冗余，并且还有更多 => 自动再拉一页
      if (this.hasMore && !this.loadingMore && el.scrollHeight <= el.clientHeight + 50) {
        this.loadMoreMedia();
      }
    },
    submitUpload() {
      this.$refs.uploadMedia.submit();
    },
    deleteMedia(name, type) {
      let notice = '确定要删除' + name + '吗? 此操作不可恢复'
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`websites/backend/media/delete`, {
          domain: this.domain,
          name: name,
          type: type
        }).then((response) => {
          if (response.data.code === 200) {
            this.getMedia();
            this.$notify({
              title: '操作成功',
              message: name + '已删除',
              type: 'success'
            });
          }
        })
      }).catch(() => {
      });
    },
    storeRenameMedia(index, type) {
      let obj = this.mediaList[index];
      this.$axios.post(`websites/backend/media/rename`, {
        domain: this.domain,
        name: this.renamedMediaName,
        url: obj.url,
        type: type
      }).then((response) => {
        if (response.data.code === 200) {
          this.renamedMediaName = '';
          this.getMedia();
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      })
    },
    queryProductsList(search = false) {
      this.productsLoading = true;
      let current_page = search === true ? 1 : this.productsPage;
      let keywords = this.productsKeywords;
      let size = this.productsSize;
      this.$axios.get('/websites/backend/products', {
        params: {
          domain: this.domain,
          lang: this.lang,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.productsLoading = false;
        if (response.data.code === 200) {
          this.productsList = response.data.data.data;
          this.productsTotal = response.data.data.total;
        }
      })
    },
    changeProductsSize(val) {
      this.productsSize = val;
      this.queryProductsList();
    },
    currentProductsChange(val) {
      this.productsPage = val;
      this.queryProductsList();
    },
    toggleProductStatus(row, index) {
      let notice = row.status ? '确定开启吗?' : '关闭后产品将不在本站显示, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/products/toggle_status', {
          lang: this.lang,
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.product_name + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.productsList[index].status = !row.status;
      });
    },
    createProductCover() {
      return {
        cover: '',
        cover_src: '',
        cover_title: '',
        cover_alt: '',
        cover_description: ''
      };
    },
    getProductImageUploadAction() {
      return this.$axios.defaults.baseURL + `websites/backend/media/upload?domain=${this.domain}&type=images`;
    },
    normalizeProductCovers() {
      let covers = Array.isArray(this.productDetail.covers) ? this.productDetail.covers : [];
      if (covers.length < 1) {
        covers = [{
          cover: this.productDetail.cover || '',
          cover_src: this.productDetail.cover_src || '',
          cover_title: this.productDetail.cover_title || '',
          cover_alt: this.productDetail.cover_alt || '',
          cover_description: this.productDetail.cover_description || ''
        }];
      }
      covers = covers.map(item => Object.assign(this.createProductCover(), item));
      this.$set(this.productDetail, 'covers', covers);
      this.syncProductCoverFields();
    },
    syncProductCoverFields() {
      if (!Array.isArray(this.productDetail.covers) || this.productDetail.covers.length < 1) {
        this.$set(this.productDetail, 'covers', [this.createProductCover()]);
      }
      const firstCover = this.productDetail.covers[0] || this.createProductCover();
      this.productDetail.cover = firstCover.cover || '';
      this.productDetail.cover_src = firstCover.cover_src || '';
      this.productDetail.cover_title = firstCover.cover_title || '';
      this.productDetail.cover_alt = firstCover.cover_alt || '';
      this.productDetail.cover_description = firstCover.cover_description || '';
    },
    addProductCover() {
      if (!Array.isArray(this.productDetail.covers)) {
        this.$set(this.productDetail, 'covers', []);
      }
      this.productDetail.covers.push(this.createProductCover());
    },
    removeProductCover(index) {
      if (!Array.isArray(this.productDetail.covers) || this.productDetail.covers.length <= 1) return;
      this.productDetail.covers.splice(index, 1);
      this.syncProductCoverFields();
    },
    async getProductDetail(row) {
      this.productDetailDiaTitle = row.product_name;
      this.productDetailLoadingText = '正在加载, 请稍候';
      this.productDetailVisible = true;
      this.productDetailLoading = true;
      await this.$axios.get(`/websites/backend/products/categories?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.productCategoriesLoading = false;
        if (response.data.code === 200) {
          this.productCategoriesOptions = response.data.data.normal;
        }
      })
      await this.$axios.get(`/websites/backend/products/detail?id=${row.id}&lang=${this.lang}`).then((response) => {
        this.productDetailLoading = false;
        if (response.data.code === 200) {
          this.productDetail = response.data.data;
          this.normalizeProductCovers();
        }
      })
    },
    deleteProduct(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/products/delete', {
          id: row.id,
          lang: this.lang
        }).then((response) => {
          if (response.data.code === 200) {
            this.queryProductsList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    addProperty() {
      this.productDetail.properties.push({
        id: '',
        product_id: this.productDetail.id,
        property_key: '',
        property_value: ''
      });
    },
    removeProperty(index) {
      this.productDetail.properties.splice(index, 1);
    },
    saveProductDetail() {
      this.syncProductCoverFields();
      this.productDetailLoadingText = '正在保存, 请稍候';
      this.productDetailLoading = true;
      this.productDetail.lang = this.lang
      this.$axios.post(`/websites/backend/products/save`, this.productDetail).then((response) => {
        if (response.data.code === 200) {
          this.productDetailLoading = false;
          this.queryProductsList();
          // this.productDetailVisible = false;
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    async addProduct() {
      this.productDetailDiaTitle = '录入产品';
      this.productDetailVisible = true;
      await this.$axios.get(`/websites/backend/products/categories?domain=${this.domain}&type=add`).then((response) => {
        this.productCategoriesLoading = false;
        if (response.data.code === 200) {
          this.productCategoriesOptions = response.data.data.normal;
          this.productCategoriesData = response.data.data.tree;
        }
      })
      this.productDetail = {
        product: '',
        cas: '',
        category_id: '',
        type: '',
        url: '',
        shape: '',
        specifications: '',
        keywords: '',
        description: '',
        og_title: '',
        og_description: '',
        covers: [this.createProductCover()],
        properties: [],
        packing_storage: {
          packing: '',
          storage: '',
          shipping: '',
          container_loading: '',
          shelf_life: ''
        },
        generals: [],
        faqs: []
      };
    },
    uploadProducts() {
      this.uploadProductsFileList = [];
      this.uploadProductsVisible = true;
    },
    submitUploadProducts() {
      this.uploadProductsLoading = true;
      this.$refs.uploadProducts.submit();
    },
    uploadProductsSuccess(response) {
      this.uploadProductsFileList = [];
      if (response.code === 200) {
        this.uploadProductsLoading = false;
        this.uploadProductsVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.queryProductsList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    downloadProductsLinks() {
      window.location.href = this.$axios.defaults.baseURL + `websites/backend/products/download_products_links?domain=${this.domain}`;
    },
    headerDbClick(data) {
      this.currentValue = data.category
      this.$set(data, 'isEdit', true)
      this.$nextTick(() => {
        this.$refs[data.id] && this.$refs[data.id].focus()
      })
    },
    handleInputBlur(event, data) {
      const inputValue = event.target.value.trim()
      if (inputValue === '') {
        this.$message({
          type: 'warning',
          message: '分类名称不能为空,请重新输入'
        })
        this.$set(data, 'isEdit', false)
      } else if (inputValue === data.category) {
        this.$set(data, 'isEdit', false)
      } else {
        this.$set(data, 'isEdit', false)
        data.category = inputValue
      }
      this.currentValue = '';
      this.saveProductCategories(this.productCategoriesData)
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      this.saveProductCategories(this.productCategoriesData)
    },
    saveProductCategories(tree) {
      this.productCategoriesLoading = true;
      const data = {
        tree: tree,
        lang: this.lang
      }
      this.$axios.post(`/websites/backend/products/categories_save`, data).then((response) => {
        this.productCategoriesLoading = false;
        if (response.data.code === 200) {
          this.$message({
            type: 'success',
            message: '已保存'
          })
        }
      })
    },
    handleMouseEnter(id) {
      this.hoveredNodeId = id;
    },
    handleMouseLeave() {
      this.hoveredNodeId = null;
    },
    toggleCategoryStatus(row) {
      const data = {
        lang: this.lang,
        id: row.id,
        status: row.status
      }
      this.$axios.post(`/websites/backend/products/categories_toggle_status`, data).then((response) => {
        if (response.data.code === 200) {
          row.status = 1 - row.status;
        }
      })
    },
    saveAddProductCategories() {
      let category = this.productCategoriesForm.category;
      let parent_id = this.productCategoriesForm.parent_id || 0;
      if (category === null || category === '') {
        this.$message({
          type: 'error',
          message: '类名不能为空'
        })
      } else {
        const data = {
          domain: this.domain,
          category: category,
          parent_id: parent_id
        }
        this.$axios.post(`/websites/backend/products/add_category`, data).then((response) => {
          if (response.data.code === 200) {
            this.manageProductsCategories()
          }
        })
      }
    },
    queryNewsList(search = false) {
      this.newsLoading = true;
      let current_page = search === true ? 1 : this.newsPage;
      let keywords = this.newsKeywords;
      let size = this.newsSize;
      this.$axios.get('/websites/backend/news', {
        params: {
          domain: this.domain,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.newsLoading = false;
        if (response.data.code === 200) {
          this.newsList = response.data.data.data;
          this.newsTotal = response.data.data.total;
        }
      })
    },
    changeNewsSize(val) {
      this.newsSize = val;
      this.queryNewsList();
    },
    currentNewsChange(val) {
      this.newsPage = val;
      this.queryNewsList();
    },
    toggleNewsStatus(row, index) {
      let notice = row.status ? '确定开启吗?' : '关闭后新闻将不在本站显示, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/news/toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.title + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.newsList[index].status = !row.status;
      });
    },
    addNews() {
      this.newsDetailForm = {
        domain: this.domain,
        title: '',
        url: '',
        content: ''
      };
      this.newsDetailTitle = '新建';
      this.newsDetailVisible = true;
    },
    getNewsDetail(row) {
      this.newsDetailVisible = true;
      this.newsDetailLoading = true;
      this.newsDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/news/detail?id=${row.id}`).then((response) => {
        this.newsDetailLoading = false;
        if (response.data.code === 200) {
          this.newsDetailForm = response.data.data;
        }
      })
    },
    saveNewsDetail() {
      this.$refs.newsDetailForm.validate(valid => {
        if (valid) {
          this.newsDetailLoading = true;
          this.$axios.post(`/websites/backend/news/save`, this.newsDetailForm).then((response) => {
            this.newsDetailLoading = false;
            if (response.data.code === 200) {
              this.newsDetailForm = {
                title: '',
                url: '',
                content: ''
              };
              this.queryNewsList();
              this.newsDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    deleteNews(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/news/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.queryNewsList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    querySupplementsList(search = false) {
      this.supplementsLoading = true;
      let current_page = search === true ? 1 : this.supplementsPage;
      let keywords = this.supplementsKeywords;
      let size = this.supplementsSize;
      this.$axios.get('/websites/backend/supplements', {
        params: {
          domain: this.domain,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.supplementsLoading = false;
        if (response.data.code === 200) {
          this.supplementsList = response.data.data.data;
          this.supplementsTotal = response.data.data.total;
          this.supplementsProgress = response.data.data.progress;
        }
      })
    },
    changeSupplementsSize(val) {
      this.supplementsSize = val;
      this.querySupplementsList();
    },
    currentSupplementsChange(val) {
      this.supplementsPage = val;
      this.querySupplementsList();
    },
    toggleSupplementsStatus(row, index) {
      let notice = row.status ? '确定开启吗?' : '关闭后新闻将不在本站显示, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/supplements/toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.title + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.supplementsList[index].status = !row.status;
      });
    },
    addSupplements() {
      this.supplementsDetailForm = {
        domain: this.domain,
        title: '',
        url: '',
        content: '',
        weight_value: 0
      };
      this.supplementsDetailTitle = '新建';
      this.supplementsDetailVisible = true;
    },
    getSupplementsDetail(row) {
      this.supplementsDetailVisible = true;
      this.supplementsDetailLoading = true;
      this.supplementsDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/supplements/detail?id=${row.id}`).then((response) => {
        this.supplementsDetailLoading = false;
        if (response.data.code === 200) {
          this.supplementsDetailForm = response.data.data;
        }
      })
    },
    deleteSupplement(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/supplements/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.querySupplementsList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    saveSupplementsDetail() {
      this.$refs.supplementsDetailForm.validate(valid => {
        if (valid) {
          this.supplementsDetailLoading = true;
          this.$axios.post(`/websites/backend/supplements/save`, this.supplementsDetailForm).then((response) => {
            this.supplementsDetailLoading = false;
            if (response.data.code === 200) {
              this.supplementsDetailForm = {
                title: '',
                url: '',
                content: '',
                weight_value: 0
              };
              this.querySupplementsList();
              this.supplementsDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    uploadSupplements() {
      this.uploadSupplementsFileList = [];
      this.uploadSupplementsVisible = true;
    },
    submitUploadSupplements() {
      this.uploadSupplementsLoading = true;
      this.$refs.uploadSupplements.submit();
    },
    uploadSupplementsSuccess(response) {
      this.uploadSupplementsFileList = [];
      if (response.code === 200) {
        this.uploadSupplementsLoading = false;
        this.uploadSupplementsVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.querySupplementsList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    async supplementsSettings() {
      this.supplementsSettingsVisible = true;
      this.supplementsSettingsLoading = true;
      this.supplementsSettingsLoadingText = '正在加载, 请稍后';
      await this.$axios.get(`/websites/backend/supplements/get_settings?domain=${this.domain}`).then((response) => {
        if (response.data.code === 200) {
          this.supplementsSettingsLoading = false;
          this.supplementsSettingsForm = {
            quantity: response.data.data.quantity,
            timing: response.data.data.timing
          }
        }
      })
    },
    saveSupplementsSettings() {
      const data = {
        domain: this.domain,
        quantity: this.supplementsSettingsForm.quantity,
        timing: this.supplementsSettingsForm.timing
      }
      this.$refs.supplementsSettingsForm.validate(valid => {
        if (valid) {
          this.supplementsSettingsLoading = true;
          this.supplementsSettingsLoadingText = '正在保存, 请稍后';
          this.$axios.post(`/websites/backend/supplements/save_settings`, data).then((response) => {
            this.supplementsSettingsLoading = false;
            if (response.data.code === 200) {
              this.querySupplementsList();
              this.supplementsSettingsVisible = false;
              this.$notify({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    async blurSaveSupplementsWeightValue(row, prop) {
      if (row[prop] > 100) {
        row[prop] = 100;
      } else if (row[prop] < 0) {
        row[prop] = 0;
      } else if (isNaN(row[prop])) {
        row[prop] = 0;
      }
      const data = {
        id: row.id,
        weight_value: row[prop]
      }
      this.$axios.post(`/websites/backend/supplements/update_weight_value`, data).then().catch();
    },
    getSeo() {
      this.seoLoading = true;
      this.$axios.get(`/websites/backend/seo?domain=${this.domain}&lang=${this.lang}`).then((response) => {
        this.seoLoading = false;
        if (response.data.code === 200) {
          this.seoForm = response.data.data;
          this.seoList = response.data.data.seo_list;
        }
      })
    },
    saveWebsiteSeo() {
      this.seoLoading = true;
      this.seoForm.lang = this.lang;
      this.$axios.post(`/websites/backend/seo/save`, this.seoForm).then((response) => {
        if (response.data.code === 200) {
          this.getSeo();
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    seoRowClassName({ row, rowIndex }) {
      if (row.used === true) {
        return 'success-row';
      }
    },
    uploadSitemapSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.getSeo();
        this.$refs.uploadSitemapRef.clearFiles();
      } else {
        this.$message.error(`上传失败, 200`);
      }
    },
    uploadSitemapError(error, file, fileList) {
      this.$message.error(`上传失败`);
    },
    async manageProductsCategories() {
      this.manageProductsCategoriesVisible = true;
      this.productCategoriesLoading = true;
      this.productCategoriesForm = {
        category: '',
        parent_id: ''
      }
      await this.$axios.get(`/websites/backend/products/categories?domain=${this.domain}`).then((response) => {
        this.productCategoriesLoading = false;
        if (response.data.code === 200) {
          this.productCategoriesOptions = response.data.data.normal;
          this.productCategoriesData = response.data.data.tree;
        }
      })
    },
    async clearProducts() {
      this.$confirm('确定清空所有产品吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在清理产品, 请稍候',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$axios.post('/websites/backend/products/clear', {
          lang: this.lang,
          domain: this.domain
        }).then((response) => {
          loading.close();
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: '所有产品已经清除',
              type: 'success'
            });
            this.queryProductsList();
          }
        })
      })
    },
    useSeo(row) {
      this.$confirm('确定使用此方案吗? 此方案不会影响已经手动修改过seo信息的条目', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/seo/use', {
          id: row.id,
          domain: this.domain
        }).then((response) => {
          if (response.data.code === 200) {
            this.getSeo();
            this.$notify({
              title: '操作成功',
              message: row.id + '号方案已经应用',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    getPartners() {
      this.partnersList = [];
      this.partnersLoading = true;
      this.$axios.get(`/websites/backend/partners?domain=${this.domain}`).then((response) => {
        this.partnersLoading = false;
        if (response.data.code === 200) {
          this.partnersList = response.data.data;
        }
      })
    },
    clearAllPartners() {
      this.$confirm('确定清空所有合作伙伴吗? 此操作不能还原', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/partners/clear', {
          domain: this.domain
        }).then((response) => {
          if (response.data.code === 200) {
            this.getPartners();
            this.$notify({
              title: '操作成功',
              message: '合作伙伴已全部清除',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    submitPartnersUpload() {
      this.$refs.uploadPartners.submit();
    },
    updateProductDetailImage(response, index = 0) {
      const imageData = response.data && response.data.original ? response.data.original.data : response.data;
      let name = imageData.name;
      let url = imageData.url;
      setTimeout(() => {
        if (!Array.isArray(this.productDetail.covers) || !this.productDetail.covers[index]) {
          this.$set(this.productDetail, 'covers', [this.createProductCover()]);
          index = 0;
        }
        this.$set(this.productDetail.covers, index, Object.assign({}, this.productDetail.covers[index], {
          cover: name,
          cover_src: url
        }));
        this.syncProductCoverFields();
      }, 0);
    },
    async getMultilingualManguages() {
      this.multilingualLanguagesList = [];
      this.multilingualLanguagesLoading = true;
      this.$axios.get(`/websites/backend/languages/multilingual?domain=${this.domain}`).then((response) => {
        this.multilingualLanguagesLoading = false;
        if (response.data.code === 200) {
          this.multilingualLanguagesList = response.data.data;
        }
      })
    },
    deleteMultilingualLanguages(row) {
      this.$confirm('确定删除此语种吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/languages/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.getMultilingualManguages();
            this.$notify({
              title: '操作成功',
              message: row.lang_show + '站已经删除',
              type: 'success'
            });
          }
        })
      }).catch();
    },
    manageMultilingualLanguages(row) {
      this.$router.push({
        name: 'websites_detail',
        params: {
          domain: this.domain
        },
        query: {
          lang: row.lang
        }
      });
      setTimeout(() => {
        window.location.reload()
      }, 0);
    },
    redoMultilingualLanguages(row) {
      this.redoMultilingualLanguagesForm = {
        domain: this.domain,
        type: '',
        action: '补充',
        lang: row.lang
      }
      this.redoMultilingualLanguagesTitle = "小语种: " + row.lang_show + "(" + row.lang + ")";
      this.redoMultilingualLanguagesVisible = true;
    },
    saveRedoMultilingualLanguages() {
      if (!this.redoMultilingualLanguagesForm.type) {
        this.$message({
          message: '请选择类型',
          type: 'error'
        });
        return false;
      }
      let str = "正在进行 " + this.redoMultilingualLanguagesForm.action + this.redoMultilingualLanguagesForm.type + " 操作, 确定吗?";
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.redoMultilingualLanguagesLoading = true;
        this.$axios.post('/websites/backend/languages/redo', this.redoMultilingualLanguagesForm).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: '操作成功',
              type: 'success'
            });
            this.redoMultilingualLanguagesVisible = false;
          }
        })
        this.redoMultilingualLanguagesLoading = false;
      })
    },
    async addMultilingualLanguages() {
      this.addMultilingualLanguagesVisible = true;
      this.addMultilingualLanguagesLoadingText = '正在加载, 请稍候';
      this.addMultilingualLanguagesLoading = true;
      this.$axios.get(`/websites/backend/languages/list?domain=${this.domain}`).then((response) => {
        this.addMultilingualLanguagesLoading = false;
        if (response.data.code === 200) {
          this.addMultilingualLanguagesFormCheckers = response.data.data;
        }
      })
    },
    toggleMultilingualLanguagesStatus(row, index) {
      this.$axios.post('/websites/backend/languages/toggle_status', {
        id: row.id,
        lang: this.lang,
        status: row.status
      })
    },
    saveAddMultilingualLanguages() {
      this.addMultilingualLanguagesLoadingText = '正在保存, 请稍候';
      this.addMultilingualLanguagesLoading = true;
      const data = {
        domain: this.domain,
        checkers: this.addMultilingualLanguagesForm.checkedValues
      }
      this.$axios.post('/websites/backend/languages/save', data).then((response) => {
        this.addMultilingualLanguagesLoading = false;
        if (response.data.code === 200) {
          this.addMultilingualLanguagesVisible = false;
          this.addMultilingualLanguagesForm = {
            checkedValues: []
          }
          this.getMultilingualManguages();
          this.$notify({
            title: '操作成功',
            message: '保存成功',
            type: 'success'
          });
        }
      })
    },
    backToEnglishVersion() {
      this.$router.push({
        name: 'websites_detail',
        params: {
          domain: this.domain
        }
      });
      setTimeout(() => {
        window.location.reload()
      }, 0);
    },
    queryKnowledgeList(search = false) {
      this.knowledgeLoading = true;
      let current_page = search === true ? 1 : this.knowledgePage;
      let keywords = this.knowledgeKeywords;
      let size = this.knowledgeSize;
      this.$axios.get('/websites/backend/knowledges', {
        params: {
          domain: this.domain,
          type: this.knowledgeType,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.knowledgeLoading = false;
        if (response.data.code === 200) {
          this.knowledgeList = response.data.data.data;
          this.knowledgeTotal = response.data.data.total;
        }
      })
    },
    changeKnowledgeSize(val) {
      this.knowledgeSize = val;
      this.queryKnowledgeList();
    },
    currentKnowledgeChange(val) {
      this.knowledgePage = val;
      this.queryKnowledgeList();
    },
    addKnowledge() {
      this.knowledgeDetailForm = {
        domain: this.domain,
        type: this.knowledgeType,
        word: '',
        is_regean: false
      };
      this.knowledgeDetailTitle = '添加' + this.knowledgeType;
      this.knowledgeDetailVisible = true;
    },
    getKnowledgeDetail(row) {
      this.knowledgeDetailVisible = true;
      this.knowledgeDetailLoading = true;
      this.knowledgesDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/knowledges/detail?id=${row.id}&type=${this.knowledgeType}`).then((response) => {
        this.knowledgeDetailLoading = false;
        if (response.data.code === 200) {
          this.knowledgeDetailForm = response.data.data;
        }
      })
    },
    deleteKnowledge(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/knowledges/delete', {
          id: row.id,
          type: this.knowledgeType,
          batch: row.batch
        }).then((response) => {
          if (response.data.code === 200) {
            this.queryKnowledgeList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    saveKnowledgeDetail() {
      this.$refs.knowledgeDetailForm.validate(valid => {
        if (valid) {
          this.supplementsDetailLoading = true;
          this.$axios.post(`/websites/backend/knowledges/save`, this.knowledgeDetailForm).then((response) => {
            this.knowledgeDetailLoading = false;
            if (response.data.code === 200) {
              this.knowledgeDetailForm = {
                word: '',
                is_regean: false
              };
              this.queryKnowledgeList();
              this.knowledgeDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    uploadKnowledge() {
      this.uploadKnowledgeFileList = [];
      this.uploadKnowledgeVisible = true;
    },
    submitUploadKnowledge() {
      this.uploadKnowledgeLoading = true;
      this.$refs.uploadKnowledge.submit();
    },
    uploadKnowledgeSuccess(response) {
      this.uploadKnowledgeFileList = [];
      if (response.code === 200) {
        this.uploadKnowledgeLoading = false;
        this.uploadKnowledgeVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.queryKnowledgeList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    queryContentsList() {
      this.contentsLoading = true;
      let current_page = this.contentsPage;
      let size = this.contentsSize;
      let type = this.contentsType;
      this.$axios.get('/websites/backend/contents', {
        params: {
          domain: this.domain,
          lang: this.lang,
          type: type,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.contentsLoading = false;
        if (response.data.code === 200) {
          this.contentsList = response.data.data.data;
          this.contentsTotal = response.data.data.total;
        }
      })
    },
    changeContentsSize(val) {
      this.contentsSize = val;
      this.queryContentsList();
    },
    currentContentsChange(val) {
      this.contentsPage = val;
      this.queryContentsList();
    },
    editContents(row) {
      this.contentsDetailVisible = true;
      this.contentsDetailLoading = true;
      this.contentsDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/contents/detail?id=${row.id}`).then((response) => {
        this.contentsDetailLoading = false;
        if (response.data.code === 200) {
          this.contentsDetailForm = response.data.data;
        }
      })
    },
    saveContentsDetail() {
      this.$refs.contentsDetailForm.validate(valid => {
        if (valid) {
          this.contentsDetailLoading = true;
          this.$axios.post(`/websites/backend/contents/save`, this.contentsDetailForm).then((response) => {
            this.contentsDetailLoading = false;
            if (response.data.code === 200) {
              this.contentsDetailForm = {
                title: '',
                url: '',
                content: ''
              };
              this.queryContentsList();
              this.contentsDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    async setCategoryPackage(d, type) {
      this.categoryPackageForm = {
        type: type,
        category_id: '',
        src: '',
        package_id: ''
      };
      this.categoryPackageLoading = true;
      this.categoryPackageVisible = true;
      await this.$axios.get(`/basic/products/packages?type=${type}`).then((response) => {
        if (response.data.code === 200) {
          this.packagesList = response.data.data
        }
      });
      this.categoryPackageTitle = '设置 ' + d.category + ' 的' + type;
      const p = this.packagesList.find(item => item.label === (type === '包装' ? d.package_type : d.sample_type));
      this.categoryPackageForm = {
        type: type,
        category_id: d.id,
        src: p ? p.src : '',
        package_id: p ? p.value : ''
      };
      this.categoryPackageLoading = false;
    },
    categoryPackageSelected(selectedValue) {
      this.categoryPackagePreviewLoading = true;
      const selectedItem = this.packagesList.find(item => item.value === selectedValue);
      if (selectedItem) {
        this.categoryPackageForm.src = selectedItem.src;
      } else {
        this.categoryPackageForm.src = '';
      }
      this.categoryPackagePreviewLoading = false;
    },
    saveCategoryPackage() {
      this.categoryPackageLoading = true;
      this.$axios.post(`/websites/backend/products/categories_package_save`, this.categoryPackageForm).then((response) => {
        if (response.data.code === 200) {
          this.manageProductsCategories();
          this.categoryPackageLoading = false;
          this.$message({
            message: '已保存',
            type: 'success'
          });
        }
      }).catch();
    },
    redoProductPackages() {
      this.redoProductPackagesForm.checkedTypes = [];
      this.redoProductPackagesForm.checkAll = false;
      this.redoProductPackagesForm.isIndeterminate = false;
      this.redoProductPackagesVisible = true;
    },
    redoProductPackagesFormCheckAll(val) {
      this.redoProductPackagesForm.checkedTypes = val ? this.redoProductPackagesForm.packageTypes : [];
      this.redoProductPackagesForm.isIndeterminate = false;
    },
    redoProductPackagesFormChange(value) {
      let checkedCount = value.length;
      this.redoProductPackagesForm.checkAll = checkedCount === this.redoProductPackagesForm.packageTypes.length;
      this.redoProductPackagesForm.isIndeterminate = checkedCount > 0 && checkedCount < this.redoProductPackagesForm.packageTypes.length;
    },
    saveRedoProductPackages() {
      this.redoProductPackagesLoading = true;
      this.$axios.post(`/websites/backend/products/categories_package_redo`, {
        domain: this.domain,
        types: this.redoProductPackagesForm.checkedTypes
      }).then((response) => {
        this.redoProductPackagesLoading = false;
        if (response.data.code === 200) {
          this.redoProductPackagesVisible = false;
          this.$notify({
            title: '操作成功',
            message: '产品图已经进入重制队列',
            type: 'success'
          });
        }
      }).catch();
    },
    async queryDeploy() {
      this.deployInfo = {
        'expire_date': '',
        'dns_status': '',
        'tencent_balance': '',
        'aliyun_balance': ''
      }
      this.loading = true;
      this.deployList = [];
      await this.$axios.get(`/websites/backend/deploy/check?domain=${this.domain}`).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.deployInfo = response.data.data.deploy_info;
          this.deployList = response.data.data.deploy_list;
        }
      });
    },
    addToDnspod() {
      const routeUrl = this.$router.resolve({
        name: 'websites_dnspod'
      });
      window.open(routeUrl.href, '_blank');
    },
    onSelectionChange(selection) {
      const newSet = new Set(selection.map(r => r.id));
      this.selectedIdSet = newSet;
      this.deployForm.items = this.deployForm.items.filter(it => newSet.has(it.id));
      selection.forEach(row => {
        const exists = this.deployForm.items.some(it => it.id === row.id)
        if (!exists) {
          this.deployForm.items.push(this.buildPayloadFromRow(row));
        } else {
          this.syncSelectedRowToForm(row);
        }
      })
    },
    rowSelectable(row, index) {
      return !['已提交', '已完成'].includes(row.status)
    },
    onRowOptionChanged(row) {
      if (!this.selectedIdSet.has(row.id)) return;
      this.syncSelectedRowToForm(row);
    },
    syncSelectedRowToForm(row) {
      const idx = this.deployForm.items.findIndex(it => it.id === row.id);
      if (idx === -1) return;
      this.$set(this.deployForm.items, idx, this.buildPayloadFromRow(row));
    },
    buildPayloadFromRow(row) {
      return {
        id: row.id,
        subdomain: row.subdomain,
        source_address: row.source_address,
        ssl: !!row.ssl,
        area: row.area
      }
    },
    async submitDeploy() {
      if (this.deployForm.items.length < 1) {
        this.$message({
          message: '未选中任何一条',
          type: 'error'
        });
        return false;
      }
      this.loading = true;
      await this.$axios.post(`/websites/backend/deploy/submit`, {
        domain: this.domain,
        list: this.deployForm.items
      }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.queryDeploy();
          this.$notify({
            title: '操作成功',
            message: '部署清单已提交',
            type: 'success'
          });
        }
      }).catch();
    },
    queryInternalLinkList(search = false) {
      this.internalLinkLoading = true;
      let current_page = search === true ? 1 : this.internalLinkPage;
      let keywords = this.internalLinkKeywords;
      let size = this.internalLinkSize;
      this.$axios.get('/websites/backend/internal_links', {
        params: {
          domain: this.domain,
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.internalLinkLoading = false;
        if (response.data.code === 200) {
          this.internalLinkList = response.data.data.data;
          this.internalLinkTotal = response.data.data.total;
        }
      })
    },
    changeInternalLinkSize(val) {
      this.internalLinkSize = val;
      this.queryInternalLinkList();
    },
    currentInternalLinkChange(val) {
      this.internalLinkPage = val;
      this.queryInternalLinkList();
    },
    addInternalLink() {
      this.internalLinkDetailForm = {
        id: '',
        domain: this.domain,
        keyword: ''
      };
      this.internalLinkDetailVisible = true;
    },
    getInternalLinkDetail(row) {
      this.internalLinkDetailVisible = true;
      this.internalLinkDetailLoading = true;
      this.internalLinksDetailTitle = '编辑';
      this.$axios.get(`/websites/backend/internal_links/detail?id=${row.id}&type=${this.internalLinkType}`).then((response) => {
        this.internalLinkDetailLoading = false;
        if (response.data.code === 200) {
          this.internalLinkDetailForm = response.data.data;
        }
      })
    },
    deleteInternalLink(row) {
      this.$confirm('确定删除吗? 此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/internal_links/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.queryInternalLinkList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    },
    saveInternalLinkDetail() {
      this.$refs.internalLinkDetailForm.validate(valid => {
        if (valid) {
          this.$axios.post(`/websites/backend/internal_links/save`, this.internalLinkDetailForm).then((response) => {
            this.internalLinkDetailLoading = false;
            if (response.data.code === 200) {
              this.internalLinkDetailForm = {
                id: '',
                domain: this.domain,
                keyword: ''
              };
              this.queryInternalLinkList();
              this.internalLinkDetailVisible = false;
              this.$message({
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    uploadInternalLink() {
      this.uploadInternalLinkFileList = [];
      this.uploadInternalLinkVisible = true;
    },
    downloadInternalLink() {
      if (!this.domain) return

      const url = this.$axios.defaults.baseURL + `websites/backend/internal_links/download?domain=${encodeURIComponent(this.domain)}`
      window.location.href = url
    },
    submitUploadInternalLink() {
      this.uploadInternalLinkLoading = true;
      this.$refs.uploadInternalLink.submit();
    },
    uploadInternalLinkSuccess(response) {
      this.uploadInternalLinkFileList = [];
      if (response.code === 200) {
        this.uploadInternalLinkLoading = false;
        this.uploadInternalLinkVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.queryInternalLinkList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    toggleInternalLinkEnabled(row, index) {
      let notice = row.enabled ? '确定激活吗?' : '禁用后本站此内链将全部失效, 确定吗?';
      let message = row.enabled ? '激活' : '禁用';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/internal_links/toggle_enabled', {
          id: row.id,
          enabled: row.enabled
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.keyword + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.internalLinkList[index].enabled = !row.enabled;
      });
    },
    querySideLoadingsList() {
      this.sideLoadingsLoading = true;
      this.$axios.get('/websites/backend/side_loading', {
        params: {
          domain: this.domain
        }
      }).then((response) => {
        this.sideLoadingsLoading = false;
        if (response.data.code === 200) {
          this.sideLoadingList = response.data.data;
        }
      })
    },
    uploadSideLoading() {
      this.uploadSideLoadingFileList = [];
      this.uploadSideLoadingVisible = true;
    },
    submitUploadSideLoading() {
      this.uploadSideLoadingLoading = true;
      this.$refs.uploadSideLoading.submit();
    },
    uploadSideLoadingSuccess(response) {
      this.uploadSideLoadingFileList = [];
      if (response.code === 200) {
        this.uploadSideLoadingLoading = false;
        this.uploadSideLoadingVisible = false;
        this.$notify({
          title: 'success',
          message: '上传成功',
          type: 'success'
        })
        this.querySideLoadingsList();
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    deleteSideLoading(row) {
      this.$confirm('确定删除吗? 删除后链接将会变成404, 并且此操作不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/side_loading/delete', {
          domain: this.domain,
          filename: row.file
        }).then((response) => {
          if (response.data.code === 200) {
            this.querySideLoadingsList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => { });
    }
  },
  beforeDestroy() {
    this.unbindMediaScroll();
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Websites/Detail/script.js